import { useTranslation } from 'react-i18next';
import { Image, ListGroup, Nav } from 'react-bootstrap'
import { useCallback, useEffect, useState, } from 'react';
import Func from '../function/Func';
import { HiStar } from "react-icons/hi2";
import SessionUtil from '../util/SessionUtil';
import ApiUtil from '../util/ApiUtil';
import ApiPath from '../util/ApiPath';
import { useNavigate } from 'react-router-dom';
import ReactLoading from "react-loading";

function LinkDriverList({ title, subtitle, page, type, isTopStore, setIsTopStore }) {
    const { t } = useTranslation(); // Use t instead of lang
    const lang = SessionUtil.getLang();
    const [list, setList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1)
    const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
    const navigate = useNavigate();
    const [recordCount, setRecordCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const getData = useCallback(async () => {
        setLoading(true);
        if(isTopStore) {
            setList([])
        }
        let driversView = page === 'driver' ? {
            "StatusCode": "ACTIVE", 
        } : type === 'linkDriver' ? {"StatusCode": "ACTIVE","IsConnectWithOperation": "0" } : {}
        let storesView = page === 'store' ? {
            "IsTopStore": true
        } : {}
            let data = {
                "PageNumber": currentPage,
                "PageSize": '10',
                "OrderBy": "Id Desc",
                "DriversView": driversView,
                "StoresView": storesView
            }

        let res;
        if (type === 'linkDriver') {
            res = await ApiUtil.postApi(ApiPath.GET_ALL_DRIVERS, data, 'POST');
        } else if (page === 'driver') {
            res = await ApiUtil.postApi(ApiPath.GET_ALL_TOP_DRIVER, data, 'POST');
        } else if (page === 'store') {
            res = await ApiUtil.postApi(ApiPath.GET_ALL_STORE, data, 'POST');
        }

        if (res && res.IsSuccessfull) {
            if(isTopStore) {
                setList(res.Result.Stores)
            } else {
                setList((prev) => type === 'linkDriver'? [...prev , ...res.Result.Driver] : page === 'driver' ?  [...prev ,...res.Result.TopDriver] : [...prev ,...res.Result.Stores]);
            }
            setRecordCount(res.Result.RecordCount);
            setLoading(false);
        }
    }, [currentPage, type, page,isTopStore]);


    useEffect(() => {
        if (isLoggedIn) {
            getData();
        }
    }, [isLoggedIn, getData,isTopStore]);
 

    const handleLink = (data) => {
        navigate('/link-driver', {
            state: { data: data }
        })
    }

    const handleShowMore = () => {
        setCurrentPage((prev) => prev + 1);
    };

    return (
        !loading ? (
         
        <div>
            <ListGroup as="ol" className='my-4 list-group-link-driver'>
                <ListGroup.Item as='div' className="border-0 pt-4">
                    <p className='mb-0 fw-bold font-16'>{page === 'store' || page === 'driver' ? title : <span>{t('Link Driver')} <Image alt="image" src="/images/rocket.png" width={20} className='img-fluid mx-2' /></span>} </p>
                    <span className='subtitle'>{page === 'store' || page === 'driver' ? <div>{subtitle} <Image alt="image" src='/images/item.png' className='img-fluid' /></div> : t('Link Driver to user operation')}</span>
                </ListGroup.Item>
                {list?.map((item, index) => {
                    return (
                        <ListGroup.Item key={index} as="li" className="border-0">
                            <div className={`d-flex justify-content-between align-items-center ${index < list.length - 1 ? 'border-bottom pb-3' : 'pb-4'}`}>
                                <div className='d-flex gap-3'>
                                    <div className='position-relative'>
                                        <span className="get-initials text-uppercase">{Func.getInitials(item?.StoreNameEn ? (lang === 'en' || item?.StoreNameAr === null ? `${item?.StoreNameEn}` : `${item?.StoreNameAr}`) : (lang === 'en' || item?.DriverNameAr === null ? `${item?.DriverNameEn}` : `${item?.DriverNameAr}`))}</span>
                                        <span className='circle-star-green'><HiStar size={12} color='#fff' /></span>
                                    </div>
                                    <div>
                                        <div className="fw-semibold">{item?.StoreNameEn ? (lang === 'en' || item?.StoreNameAr === null ? item?.StoreNameEn : item?.StoreNameAr) : (lang === 'en' || item?.DriverNameAr === null ? `${item.DriverNameEn}` : `${item.DriverNameAr}`)}</div>
                                        <span className='subtitle'>{page === 'store' ? item.StoreLocation : item.Address}</span>
                                    </div>
                                </div>
                                <Nav.Link className="color-link" onClick={() => handleLink(item)} href='#'>{(page === 'store' || page === 'driver') ? '' : t('Link')}</Nav.Link>
                            </div>
                        </ListGroup.Item>
                    );
                })}
                  {list.length < recordCount && <ListGroup.Item as={'button'} onClick={handleShowMore} className="border-0 font-13 fw-semibold text-center py-2 bg-light text-main-color rounded-0">
                    {t("Show More")}
                </ListGroup.Item>}
                {list.length === 0 && <p className='noData'>{t('There is no information to display')}.</p>}


            </ListGroup>
        </div>
        ) : (
            <div className="loading-style h-auto">
              <ReactLoading
                type={"bars"}
                color={"#c8c8c8"}
                height={"50px"}
                width={"50px"}
              />
            </div>
          ) 
    )
}

export default LinkDriverList;